var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 74,
    viewBox: "0 0 131 74",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M27.7918 8H3.75C1.67893 8 0 6.32107 0 4.25C0 2.17893 1.67893 0.5 3.75 0.5H32.241C34.5401 0.5 36.6369 1.81368 37.6399 3.88236L58.3601 46.6176C59.3631 48.6863 61.4599 50 63.759 50H103.049C105.692 50 108.024 48.2699 108.791 45.74L121.693 3.16265C122.172 1.58137 123.63 0.5 125.282 0.5C127.846 0.5 129.654 3.0154 128.837 5.44562L112.875 52.9125C112.053 55.3548 109.764 57 107.188 57H59.7082C57.4356 57 55.358 55.716 54.3416 53.6833L33.1584 11.3167C32.142 9.28401 30.0644 8 27.7918 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 65,
    cy: 65.5,
    rx: 9,
    ry: 8.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 104,
    cy: 65.5,
    rx: 9,
    ry: 8.5,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.2502191e.svg";
export { ForwardRef as ReactComponent };